import React, { useState, Fragment } from 'react';
import { Row } from 'reactstrap';
import { Colxx } from '../../../../../../components/common/CustomBootstrap';
import moment from 'moment';

import Message from '../Message/Message';
import { AddMessageButton } from '../Button/AddButton';
import ResponseInformation from './ResponseInformation';
import Example from '../Example/Example';

export default function ExampleResponse({ elem, reloadBotResponse, child, SaveRecommenderQuestionCode, favouriteResponse, showFav, viewResponse, userRole, propertyList, selectedLang, historyUpdator, isLogHistory, isButtonShow }) {
  const [isAddMsg, setIsAddMsg] = useState(SaveRecommenderQuestionCode === undefined ? false : true);

  const generateButtonGroup = () => {
    return (
      <Row>
        <Colxx xs="12" sm="12" md="12" lg="6" className="mb-4">
          <Row>
            <Colxx xs="12" sm="4" className="mb-1">
              <div
                onClick={() => {
                  setIsAddMsg(true);
                }}
              >
                <AddMessageButton className="add-button" />
              </div>
            </Colxx>
          </Row>
        </Colxx>
      </Row>
    );
  };

  return (
    <Row>
      <Colxx xxs="12" xs="3">
        {child === undefined && (<ResponseInformation elem={elem} favouriteResponse={favouriteResponse} reloadBotResponse={reloadBotResponse} showFav={showFav} userRole={userRole} propertyList={propertyList} selectedLang={selectedLang} historyUpdator={historyUpdator} />)}
        {isLogHistory === true &&
          <Fragment>
            Version On:<br />
            {moment(elem.updatedDate).format(
              'DD-MM-YYYY h:mm a'
            )}<br /><br />
            {elem.historyUpdator !== undefined &&
              <Fragment>
                Updated By:<br />
                {elem.historyUpdator}<br /><br />
              </Fragment>
            }
            {elem.action !== undefined &&
              <Fragment>
                Action:<br />
                <span style={{ color: `${elem.action === "Deleted" ? "red" : ""}` }}>{elem.action}</span>
              </Fragment>
            }

          </Fragment>
        }
      </Colxx>
      <Colxx xxs="12" xs={child === undefined ? "9" : isLogHistory === true ? "9" : "12"}>
        {SaveRecommenderQuestionCode === undefined && (<Row>
          <Colxx md="12" className="mb-2">
            <Example example={elem.response.example} child={viewResponse !== true ? child : undefined} historyUpdator={historyUpdator} />
          </Colxx>
        </Row>)}

        {isAddMsg ? (
          <Row>
            <Colxx md="12" className="mb-2">
              <Message
                isAdd={isAddMsg}
                code={elem.query.code}
                type={elem.response.type}
                msg={''}
                messages={elem.response.messages}
                index={0}
                example={elem.response.example}
                setIsAddMsgToFalse={() => setIsAddMsg(false)}
                reloadBotResponse={reloadBotResponse}
                child={child}
                SaveRecommenderQuestionCode={SaveRecommenderQuestionCode}
                selectedLang={selectedLang}
                historyUpdator={historyUpdator}
              />
            </Colxx>
          </Row>
        ) : null}
        {viewResponse !== true && isButtonShow && generateButtonGroup()}
      </Colxx>
    </Row>
  );
}
